import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './BancodeDados.css';
import CardsVerbetes from '../../components/BancoVerbetesComponents/CardsVerbetes';
import AutoresLista from '../../components/Autores/Autoreslista'
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Container } from '@mui/material';

// Criando uma única instância do QueryClient para ser usada em toda a aplicação
const queryClient = new QueryClient();

export default function BancodeDados() {
  return (
   
    <QueryClientProvider client={queryClient}>
          

      <div>
        <div className="TituloBancodeDados">
          <div className="row">
            <div className="col-md-12">
            <Typography
             variant="h2"
             align="center"
             gutterBottom
             style={{
               fontFamily: "'Lato', serif",
               color: "white",
               borderBottom: "4px solid #d4af37",
               paddingBottom: "10px",
               textTransform: "uppercase",
               animation: "glow 2s infinite alternate",
               marginTop: "7%"  // Aqui é onde você define o espaço superior

             }}
           > Obras pastorais e Doutrinárias
           </Typography>
            </div>
          </div>
        </div>

        <section className="BancodeDados-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">

            
              <Typography
  variant="h2"
  align="center"
  gutterBottom={false} // Desativa o espaçamento extra
  style={{
    fontFamily: "'Lato', serif",
    color: "#800020",
    borderBottom: "4px solid #d4af37",
    paddingBottom: "10px",
    textTransform: "uppercase",
    animation: "glow 2s infinite alternate",
    marginTop: "7%",
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
    marginBottom: "10px", // Reduzindo o espaço extra abaixo do título
  }}
>
  Banco de Dados
</Typography>

 
                <CardsVerbetes />
              </div>
              <div class="col-lg-4">
<AutoresLista />
</div>
            </div>
          </div>
        </section>
      </div>
      
    </QueryClientProvider>
 
  );
}
